import { StyledIconCapa } from './IconCapa.styled';

const IconCapa = () => {
  return <StyledIconCapa />;
};

export default IconCapa;
